import React from 'react';
import { Edit, DisabledInput } from 'react-admin';
import SectorForm from '../SectorForm';

function SectorEdit(props) {
  return (
    <Edit undoable={false} {...props}>
      <SectorForm redirect="list">
        <DisabledInput label="Id" source="id" />
      </SectorForm>
    </Edit>
  );
}

export default SectorEdit;
